import officialRoles from "./officialRoles";

export default {
  forms: {
    StaffAdd: {
      endpoint: "v1/#sport/o/#0/roles",
      parameters: ["organizationId"],
      method: "POST",
      successmessage: "Staff member added",
      dataFields: ["personId", "role", "seasonId"],
      fields: [
        {
          name: "nameFullLocal",
          type: "display",
          source: "extra"
        },
        {
          name: "role",
          type: "select",
          data: officialRoles
        }
      ]
    },
    StaffEdit: {
      endpoint: "v1/#sport/o/#0/roles/#1",
      parameters: ["organizationId", "roleId"],
      method: "PUT",
      successmessage: "Staff member edited",
      dataFields: ["personId", "role", "seasonId"],
      fields: [
        {
          name: "nameFullLocal",
          type: "display",
          source: "extra"
        },
        {
          name: "role",
          type: "select",
          data: officialRoles
        }
      ]
    }
  }
};
